import React from 'react';
import ModuleRoute from 'holocron-module-route';
import type { ChildRoutes } from 'one-app-types';
import { Store } from 'redux';
import type { EnterHook, RouterState } from '@americanexpress/one-app-router';
import url from 'url';
import authenticatedReducer, {
  getAuthenticationState,
} from './ducks/authenticated';
import { OneAppStore } from './types/OneAppStore';

const getDestinationUrl = (reduxState: OneAppStore, nextState: RouterState) => {
  const origin = reduxState.getIn(['browser', 'location', 'origin']);
  const currentUri = `${origin}${nextState.location.pathname}`;
  const loginUrl = reduxState.getIn(['config', 'loginUrl']);
  const destURL = `${currentUri}${nextState.location.search}`;
  return `${loginUrl}?DestPage=${encodeURIComponent(destURL)}`;
};

export const requireAuth: (store: Store) => EnterHook = (store: Store) => {
  const { dispatch, getState } = store;
  return async (nextState, replace, callback) => {
    const state = getState();
    const isAuthenticated = await dispatch(getAuthenticationState());
    if (!isAuthenticated) {
      replace({
        state: url.parse(getDestinationUrl(state, nextState)),
      });
    }
    callback!();
  };
};

const childRoutes: ChildRoutes<typeof authenticatedReducer> = (store) => (
  <ModuleRoute path="/">
    <ModuleRoute
      key="/digital-buyer-onboarding"
      path="digital-onboarding"
      moduleName="one-ap-digital-buyer-onboarding"
      onEnter={requireAuth(store)}
    />
    <ModuleRoute
      key="/digital-buyer-onboarding/corporate"
      path="digital-onboarding/corporate"
      moduleName="one-ap-digital-buyer-onboarding"
      onEnter={requireAuth(store)}
    />
    <ModuleRoute
      key="/digital-buyer-onboarding/add-a-bank"
      path="digital-onboarding/add-a-bank"
      moduleName="one-ap-unauthenticated-landing"
    />
    <ModuleRoute
      key="/corp-buyer-onboarding"
      path="digital-onboarding/corporate-ao"
      moduleName="one-ap-unauthenticated-landing"
    />
  </ModuleRoute>
);

export default childRoutes;
